// Shared category options for tennis competitions
export const CATEGORY_OPTIONS = [
    { value: 'ATP', label: 'ATP' },
    { value: 'Billie Jean King Cup', label: 'Billie Jean King Cup' },
    { value: 'Challenger', label: 'Challenger' },
    { value: 'Davis Cup', label: 'Davis Cup' },
    { value: 'Exhibition', label: 'Exhibition' },
    { value: 'ITF Men', label: 'ITF Men' },
    { value: 'ITF Women', label: 'ITF Women' },
    { value: 'UTR Men', label: 'UTR Men' },
    { value: 'UTR Women', label: 'UTR Women' },
    { value: 'WTA', label: 'WTA' },
    { value: 'WTA 125K', label: 'WTA 125K' },
] as const

export type Category = typeof CATEGORY_OPTIONS[number]['value']

// Gender options for competitions
export const GENDER_OPTIONS = [
    { value: 'men', label: 'Men' },
    { value: 'women', label: 'Women' },
    { value: 'mixed', label: 'Mixed' },
] as const

export type Gender = typeof GENDER_OPTIONS[number]['value']

// Type options for competitions (singles vs doubles)
export const TYPE_OPTIONS = [
    { value: 'singles', label: 'Singles' },
    { value: 'doubles', label: 'Doubles' },
    { value: 'mixed', label: 'Mixed' },
] as const

export type CompetitionType = typeof TYPE_OPTIONS[number]['value']

// Match lifecycle states. Values must match ACE's LifecycleState GraphQL enum
// exactly (apps/ace/internal/service/models.go) — they're sent verbatim as a
// carousel widget filter and compared as-is.
export const LIFECYCLE_OPTIONS = [
    { value: 'LIVE', label: 'Live' },
    { value: 'UPCOMING', label: 'Upcoming' },
    { value: 'ENDED', label: 'Ended' },
] as const

export type LifecycleState = typeof LIFECYCLE_OPTIONS[number]['value']

// Court surfaces. Sportradar-driven vocabulary; no ACE enum backs these.
export const SURFACE_OPTIONS = [
    { value: 'HARD', label: 'Hard' },
    { value: 'CLAY', label: 'Clay' },
    { value: 'GRASS', label: 'Grass' },
    { value: 'CARPET', label: 'Carpet' },
] as const

export type Surface = typeof SURFACE_OPTIONS[number]['value']

// Draw-round codes. These are the stable ACE round codes used for filtering,
// distinct from the editable per-match round labels in MatchDetail.
export const ROUND_OPTIONS = [
    { value: 'F', label: 'Final' },
    { value: 'SF', label: 'Semifinal' },
    { value: 'QF', label: 'Quarterfinal' },
    { value: 'R16', label: 'Round of 16' },
    { value: 'R32', label: 'Round of 32' },
    { value: 'R64', label: 'Round of 64' },
    { value: 'R128', label: 'Round of 128' },
    { value: 'RR', label: 'Round Robin' },
    { value: 'Q1', label: 'Qualifying 1' },
    { value: 'Q2', label: 'Qualifying 2' },
    { value: 'Q3', label: 'Qualifying 3' },
] as const

export type Round = typeof ROUND_OPTIONS[number]['value']
